import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
    const location = useLocation();
    
    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 backdrop-blur-xl bg-black/20 border-b border-white/10"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
                <Link to="/" data-testid="logo-link" className="flex items-center gap-2">
                    <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-blue-600 to-purple-600 flex items-center justify-center text-white font-heading font-black text-lg">
                        G
                    </div>
                    <span className="font-heading font-black text-xl tracking-tight text-white">
                        Globic India<span className="text-blue-400">.</span>
                    </span>
                </Link>
                
                <nav className="flex items-center gap-8">
                    <Link 
                        to="/" 
                        className={`font-medium transition-colors ${
                            location.pathname === "/" 
                                ? "text-amber-400" 
                                : "text-white hover:text-amber-400"
                        }`}
                    >
                        Home
                    </Link>
                    <Link 
                        to="/product-catalog" 
                        className={`font-medium transition-colors ${
                            location.pathname === "/product-catalog" 
                                ? "text-amber-400" 
                                : "text-white hover:text-amber-400"
                        }`}
                    >
                        Products
                    </Link>
                </nav>
            </div>
        </header>
    );
}
